import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signOut } from "./authSlice/authSlice";
import { resetConsult } from "./consultSlice/consultSlice";
import { shootToast } from "codekit";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_CASTOR_ENDPOINT,
  mode: "cors",
  timeout: process.env.REACT_APP_CASTOR_TIMEOUT,
  prepareHeaders: (Headers, { getState }) => {
    const token = getState().persistedReducer.token;
    Headers.set("Accept", "application/json");
    if (token) {
      Headers.set("Authorization", `Bearer ${token}`);
    }
    return Headers;
  },
});

const baseQueryWithLogOut = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  let autoHide = true;
  let text = "";
  let variant = "";

  const statusCode = result?.error?.status;
  const responseStatusCode = result?.meta?.response?.status;
  const customParam = args?.body?.customParam; // Valido si el customParam está presente

  switch (statusCode) {
    case "TIMEOUT_ERROR":
      text = "No se pudo conectar con la plataforma. Por favor, intenta de nuevo más tarde.";
      variant = "error";
      break;
    case 401:
      api.dispatch(signOut());
      break;
    case 403:
    case 405:
    case 422:
    case 500:
      const errors = result?.error?.data?.errors;
      if (errors?.message) {
        text = errors?.message;
        if (errors?.exception && errors?.exception.indexOf("Duplicate entry") > -1) {
          text = "La informacion que intenta guardar ya existe";
        }
      } else if (errors) {
        const errorsProperties = Object.getOwnPropertyNames(errors);
        errorsProperties.forEach((property) => {
          text += errors[property];
        });
      } else {
        text = result?.error?.data?.error || "Ha ocurrido un error en el servidor.";
      }
      variant = "error";
      break;
    default:
      break;
  }

  switch (responseStatusCode) {
    case 201:
      //valido Si el parámetro customParam está presente entonces NO lleno el text ni el variant
      if (!customParam) {
        api.dispatch(resetConsult());
        text = "La informacion ha sido cargada con exito!";
        variant = "success";
      }

      break;
    case 200:

      if (customParam) {
        break;
      }

      const method = result?.meta?.request?.method;
      variant = "success";

      if (method === "PUT") {
        text = "El registro ha sido actualizado con exito!";
      }

      if (method === "DELETE") {
        text = "El estado del registro es " + (result?.data?.original?.regestxx ?? result?.data?.data?.regestxx);
        // text = result.data?.data?.message;
      }

      // if(method === "POST") {
      //   text = "La informacion ha sido cargada con exito!";
      // }

      break;
    default:
      break;
  }

  if (text !== "") {
    shootToast({
      variant,
      text,
      duration: 5000,
      autoHide,
    });
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithLogOut,
  endpoints: (builder) => ({}),
  tagTypes: ["Create", "Consult"],
});
